import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { defaultConfig, EmojiUrlFn } from '@components/emoji-picker/emoji-picker.interface';
import { EmojiPickerService } from '@components/emoji-picker/emoji-picker.service';
import { BaseCellComponent } from '../base-cell.component';

interface IItem {
    name: string;
    path_name: string | null;
    color: string | null;
    emoji: string | null;
    list_view_tree_as_folder: boolean;
}

/**
 * Компонент, отвечающий за рендер ячеек в табличном движке, для ячеек с типом данных "Список".
 * Используется в родительском table.component для снижения громоздкости.
 */
@Component({
    selector: 'app-table-cell-list',
    templateUrl: './list-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableCellListComponent extends BaseCellComponent implements OnInit {
    private readonly emojiPickerService = inject(EmojiPickerService);
    private readonly emojiUrlFn: EmojiUrlFn = this.emojiPickerService.getEmojiUrlFn(defaultConfig);

    items: IItem[] = [];

    ngOnInit() {
        if (typeof this.row[this.alias + '_with_decorations'] === 'object') {
            this.items = this.row[this.alias + '_with_decorations'] as IItem[];
        } else {
            const name = this.getRawValue();
            if (!!name) {
                this.items = [{ name, path_name: null, emoji: null, color: null, list_view_tree_as_folder: null }];
            }
        }
    }

    getColor(item: IItem) {
        return !item.color ? '#d4d4d4' : `#${item.color}`;
    }

    getIcon(item: IItem): string | null {
        return !this.hasIcon(item) ? null : this.emojiUrlFn(item.emoji);
    }

    hasIcon(item: IItem) {
        return !!item.emoji;
    }
}
